module.exports = __webpack_public_path__ + "c58d59ddead995f9d2905362247af486.svg";